import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

  static values = {
    phaseKey: String,
    phaseIndex: Number
  }

  connect() {

    // console.log("!!!!!!!!!!Form Visibility Controller connected!!!!!!!!!!!");
    // // // console.log(`connect version [form-visibility] connect at ${performance.now().toFixed(2)}`);

    // // console.log("Phase Key:", this.phaseKeyValue)
    // // console.log("Phase Index:", this.phaseIndexValue)

    this.form = this.element.querySelector("form");

    if (this.form) {
      this._clearHiddenFields = this.clearHiddenFields.bind(this);
      this.form.addEventListener("submit", this._clearHiddenFields);
      // // console.log("Listener attached to form:", this.form.action);
    } else {
      console.warn("No form found to attach submit handler.");
    }

    this.evaluate();
    this.element.addEventListener("change", this.evaluate.bind(this));
  }

  disconnect() {
    // // // console.log("Form Visibility Controller disconnected");
    if (this.form && this._clearHiddenFields) {
      this.form.removeEventListener("submit", this._clearHiddenFields);
    }
  }

  evaluate(event) {
    // console.log("Evaluating form visibility...");
    // // console.log("Event:", event);
    // // console.log("Event target:", event?.target);
    const active = document.activeElement;

    // Protect against hiding fields the user is typing in
    if (active?.name?.includes("rtl_plan_yes_other")) {
      // // console.log("Skipping evaluate while focused in rtl_plan_yes_other");
      return;
    }

    // Delay evaluation slightly if they're interacting with the multi-select
    if (active?.tagName === "SELECT" && active?.multiple && active?.name?.includes("rtl_plan_yes")) {
      // // console.log("Deferring evaluate during rtl_plan_yes interaction");
      setTimeout(() => this.evaluate(), 100);
      return;
    }

    this._doEvaluate();
  }

  _doEvaluate() {

    const generalFields = ["attendance"];
    const generalValues = this.normalize(this.collectValues.call(this, generalFields));
    // // console.log("General values", generalValues);

    // === RTL visibility logic ===
    const rtlFields = [
      "rtl_plan_in_place",
      "rtl_plan_yes",
      "rtl_plan_yes_other",
      "rtl_plan_no",
      "rtl_plan_no_other",
      "rtl_plan_no_complete"
    ];

    const rtlValues = this.normalize(this.collectValues.call(this, rtlFields));
    // // console.log("RTL values", rtlValues);

    const inPlace = (rtlValues["rtl_plan_in_place"] || "").toLowerCase();
    const planNo = (rtlValues["rtl_plan_no"] || "").toLowerCase();

    this.toggleGroup("rtl_plan_yes", inPlace === "yes");
    this.toggleGroup("rtl_plan_yes_other", inPlace === "yes");

    this.toggleGroup("rtl_plan_no", inPlace === "no");
    this.toggleGroup("rtl_plan_no_other", inPlace === "no");
    this.toggleGroup("rtl_plan_no_complete", inPlace === "no" && planNo === "yes");

    // === Information visibility logic ===
    const informationFields = [
      "cleared_to_progress",
      "completed_by",
      "completed_by_other",
      "phase_completion_date",
      "notes"
    ];

    const informationValues = this.normalize(this.collectValues.call(this, informationFields));
    // // console.log("Information values", informationValues);

    const attendance = (generalValues["attendance"] || "").toLowerCase();

    const showInformation = attendance === "yes";

    // this.toggleSection("information", showInformation);
    const clearedToProgress = (informationValues["cleared_to_progress"] || "").toLowerCase();
    const showClearedToProgress = clearedToProgress === "yes";
    const completedBy = (informationValues["completed_by"] || "").toLowerCase();

    // this.toggleGroup("completed_by", showClearedToProgress);
    // this.toggleGroup("phase_completion_date", showClearedToProgress);
    // this.toggleGroup("notes", showClearedToProgress);
    // this.toggleGroup("completed_by_other", showClearedToProgress && completedBy === "other");


    // === return_full_contact_practice visibility logic ===
    const fullContactPracticeFields = [
      "completed_full_contact_practice",
      "date_first_full_practice"
    ];

    const fullContactPracticeValues = this.normalize(this.collectValues.call(this, fullContactPracticeFields));
    // // console.log("Full Contact Practice values", fullContactPracticeValues);

    const completedFullContact = (fullContactPracticeValues["completed_full_contact_practice"] || "").toLowerCase();
    const showFullContactPractice = completedFullContact === "yes";
    const showReturnToParticipationSection = completedFullContact === "yes";

    this.toggleGroup("date_first_full_practice", showFullContactPractice);

    this.toggleSection("return_to_participation", showReturnToParticipationSection);


    // == return_to_participation visibility logic ===
    const returnToParticipationFields = [
      "cleared_unrestricted_participation",
      "return_date",
      "rtp_athorizer",
      "clearance_date"
    ];

    const returnToParticipationValues = this.normalize(this.collectValues.call(this, returnToParticipationFields));

    // // console.log("Return to Participation values", returnToParticipationValues);


    const clearedUnrestricted = (returnToParticipationValues["cleared_unrestricted_participation"] || "").toLowerCase();
    const showReturnToParticipationFields = clearedUnrestricted === "yes";


  // rtp_phase[answers][return_to_participation][cleared_unrestricted_participation]

    this.toggleGroup("return_date", showReturnToParticipationFields);
    this.toggleGroup("rtp_athorizer", showReturnToParticipationFields);
    this.toggleGroup("clearance_date", showReturnToParticipationFields);

    let shouldActivateInfoSection = false;
    let showOnlyClearedToProgress = true;
    let showOtherInfoFields = false;

    if (Object.keys(returnToParticipationValues).length === 0) {
      // // // console.log("NOOOO Return to Participation values detected");
      shouldActivateInfoSection = showInformation;
    } else {
      // // // console.log("Return to Participation values detected");
      shouldActivateInfoSection = showClearedToProgress || showReturnToParticipationFields;
    }

    // const shouldActivateInfoSection = showClearedToProgress || showReturnToParticipationFields;

    // this.activateInformationSection((showClearedToProgress || showReturnToParticipationFields), completedBy);
    this.activateInformationSection(shouldActivateInfoSection, completedBy);

  }
  activateInfoClearedToProgress(shouldShow) {
    this.toggleSection("information", shouldShow);
  }

  toggleDependentInformationFields(shouldShow, completedBy) {
    this.toggleGroup("completed_by", shouldShow);
    this.toggleGroup("phase_completion_date", shouldShow);
    this.toggleGroup("notes", shouldShow);
    this.toggleGroup("completed_by_other", shouldShow && completedBy === "other");
  }


  activateInformationSection(shouldShow, completedBy) {
    this.toggleSection("information", shouldShow);
    //if the cleared_unrestricted_participation is present, it is the driving force behind the information section visibility

    //if it is not, then generalValues["attendance"] === "yes" drives it
    this.toggleGroup("completed_by", shouldShow);
    this.toggleGroup("phase_completion_date", shouldShow);
    this.toggleGroup("notes", shouldShow);
    this.toggleGroup("completed_by_other", shouldShow && completedBy === "other");
  }

  handleBeforeSubmit(event) {
    // // console.log("Cleaning up hidden required fields before browser validation...");
    if (this.shouldConfirmPhaseFourAcademicModifications(event) && !window.confirm(this.phaseFourAcademicModificationsMessage())) {
      event.preventDefault();
      return;
    }

    this.clearHiddenFields(event);
  }

  shouldConfirmPhaseFourAcademicModifications(event) {
    const submitter = event.params?.submitter || event.submitter || event.target;
    if (this.phaseIndexValue !== 4) return false;
    if (submitter?.name !== "workflow_action" || submitter?.value !== "complete") return false;

    const rtlValues = this.normalize(this.collectValues.call(this, ["rtl_plan_in_place"]));
    return (rtlValues["rtl_plan_in_place"] || "").toLowerCase() === "yes";
  }

  phaseFourAcademicModificationsMessage() {
    return "This Phase 4 still has an active Return to Learning (RTL) plan. Phase 5 and Phase 6 cannot start until a later phase records that the RTL plan is no longer in place. Complete this phase anyway?";
  }

  clearHiddenFields(event) {
    // event.preventDefault();

    // console.log("Clearing hidden fields on form submit");
    const hiddenFields = this.element.querySelectorAll(".d-none input, .d-none select, .d-none textarea");

    hiddenFields.forEach(field => {

      if (field.matches('select[name$="[activities_subsection][activity][]"]')) return

      this.clearField(field);
      field.required = false; // Prevent “not focusable” error
    });
  }

  clearField(field) {
    // console.log(`Clearing field: ${field.name || field.id || field.tagName}`);
    // console.log(`Field type: ${field.type}, tagName: ${field.tagName}`);
    if (field.tagName === "SELECT") {
      Array.from(field.options).forEach(option => option.selected = false);
    } else if (field.type === "checkbox" || field.type === "radio") {
      field.checked = false;
    } else {
      field.value = "";
    }
  }

  normalize(values) {
    Object.entries(values).forEach(([key, val]) => {
      if (Array.isArray(val)) {
        if (val.length === 1) {
          values[key] = val[0];  // unwrap
        } else if (val.length === 0) {
          values[key] = "";      // treat as blank
        }
      }
    });
    return values;
  }

  toggleSection(key, show) {
    const els = this.element.querySelectorAll(`[data-section-key='${key}']`);
    els.forEach(el => {
      const isHidden = el.classList.contains("d-none");

      if (show && isHidden) {
        el.classList.remove("d-none");
        requestAnimationFrame(() => el.classList.add("fade", "show"));
      } else if (!show && !isHidden) {
        el.classList.remove("show");
        el.addEventListener("transitionend", () => {
          el.classList.add("fade", "d-none");
        }, { once: true });
      }
    });
  }

  toggleGroup(key, show) {
    // console.log(`Toggling group: ${key}, show: ${show}`);
    const els = this.element.querySelectorAll(`[data-rtl-key='${key}']`);
    els.forEach(el => {
      // console.log(`Toggling element: ${el}, show: ${show}`);
      const isHidden = el.classList.contains("d-none");

      if (show && isHidden) {
        el.classList.remove("d-none");
        requestAnimationFrame(() => el.classList.add("fade", "show"));
      } else if (!show && !isHidden) {
        el.classList.remove("show");
        el.addEventListener("transitionend", () => {
          el.classList.add("d-none");
        }, { once: true });
      }
    });
  }

  collectValues(fields) {
  const values = {};

  fields.forEach(field => {
    const selector = `[name$='[${field}]'], [name$='[${field}][]']`;
    const inputs = this.element.querySelectorAll(selector);
    if (inputs.length === 0) return;

    const input = inputs[0];
    const isMultiSelect = input.tagName === "SELECT" && input.multiple;
    const isCheckboxOrRadioGroup = !isMultiSelect && inputs.length > 1 && ["checkbox", "radio"].includes(input.type);
    const isSingularSelectArrayNamed = input.tagName === "SELECT" && !input.multiple && input.name.endsWith("[]");

    if (isMultiSelect) {
      values[field] = Array.from(input.selectedOptions).map(opt => opt.value);
    } else if (isCheckboxOrRadioGroup) {
      values[field] = Array.from(inputs).filter(i => i.checked).map(i => i.value);
    } else if (isSingularSelectArrayNamed) {
      values[field] = input.value;
    } else {
      values[field] = input.value;
    }
  });

  return values;
}




}
